import { render, staticRenderFns } from "./PopupsUpdateData.vue?vue&type=template&id=67cda5a6&"
import script from "./PopupsUpdateData.vue?vue&type=script&lang=js&"
export * from "./PopupsUpdateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports